import React from "react";
import { useWhiteList } from "./useWhiteList";
import moment from "moment";
import "./WhiteList.css";

const YEARS_HARI_MINGGU = ["2025", "2026"];
const YEARS_HARI_LIBUR = ["2023", "2024", "2025", "2026"];

// Satu komponen untuk dua daftar (Hari Libur & Hari Minggu), karena strukturnya sama
const WhitelistSection = ({
  title,
  dateValue,
  onDateChange,
  years,
  tahun,
  onTahunChange,
  onAdd,
  rows,
  formatTanggal,
  onDelete,
}) => (
  <>
    <div className="whitelist-toolbar">
      <div className="whitelist-fields">
        <input
          className="whitelist-input"
          type="date"
          aria-label="Pilih tanggal"
          value={dateValue}
          onChange={(e) => onDateChange(e.target.value)}
        />
        <select
          className="whitelist-select"
          aria-label="Pilih tahun"
          value={tahun}
          onChange={(e) => onTahunChange(e.target.value)}
        >
          <option disabled hidden>
            Pilih Tahun
          </option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
      <button className="whitelist-btn whitelist-btn-primary" onClick={onAdd}>
        Add
      </button>
    </div>

    <div className="whitelist-heading">
      <h3>{title}</h3>
      <span>{rows ? rows.length : 0} tanggal</span>
    </div>

    <div className="whitelist-table-scroll">
      <table className="whitelist-table">
        <thead>
          <tr>
            <th className="col-no">No</th>
            <th>Tanggal</th>
            <th className="col-action" />
          </tr>
        </thead>
        <tbody>
          {rows &&
            rows.map((data, index) => (
              <tr key={`${data.tanggal}-${index}`}>
                <td className="col-no">{index + 1}</td>
                <td>{formatTanggal(data)}</td>
                <td className="col-action">
                  <button
                    className="whitelist-btn whitelist-btn-danger"
                    onClick={() => onDelete(data.tanggal)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {(!rows || rows.length === 0) && (
        <div className="whitelist-empty">Belum ada tanggal.</div>
      )}
    </div>
  </>
);

const WhiteList = () => {
  const {
    handleAddTanggalWhitelist,
    handleDeleteTanggalWhitelist,
    subMenu,
    tanggal,
    setTanggal,
    tahun,
    setTahun,
    sortTanggalHariLibur,
    sortWhitelistHariMinggu,
    tanggalWhitelistHariMinggu,
    handleDeleteWhitelistHariMinggu,
    handleAddWhitelistHariMinggu,
    setTanggalWhitelistHariMinggu,
  } = useWhiteList();

  return (
    <div className="container-whitelist">
      <div className="wrapper-card-whitelist">
        <div className="warning-whitelist" role="note">
          <span className="warning-icon" aria-hidden="true">
            &#9888;
          </span>
          <div className="warning-text">
            <p>
              Jika tanggal sudah dimasukkan, pada <b>hari H</b> sistem akan
              menambahkan secara otomatis <b>1 Hari kerja</b> di Jam 2 Sore.
            </p>
            <p>
              Jika terdapat lembur pada hari yang telah dimasukkan,{" "}
              <b>sistem akan membaca sebagai lembur</b> dan{" "}
              <b>tidak akan menambahkan hari kerja</b>, sistem hanya menambahkan{" "}
              <b>Lembur Libur</b>.
            </p>
          </div>
        </div>

        {subMenu === "hariMinggu" ? (
          <WhitelistSection
            title="Whitelist Hari Minggu"
            dateValue={tanggalWhitelistHariMinggu}
            onDateChange={setTanggalWhitelistHariMinggu}
            years={YEARS_HARI_MINGGU}
            tahun={tahun}
            onTahunChange={setTahun}
            onAdd={() => handleAddWhitelistHariMinggu()}
            rows={sortWhitelistHariMinggu}
            formatTanggal={(data) =>
              moment(data && data.tanggal)
                .utcOffset("+0700")
                .format("ddd MMM DD YYYY")
            }
            onDelete={handleDeleteWhitelistHariMinggu}
          />
        ) : (
          <WhitelistSection
            title="Whitelist Hari Libur"
            dateValue={tanggal}
            onDateChange={setTanggal}
            years={YEARS_HARI_LIBUR}
            tahun={tahun}
            onTahunChange={setTahun}
            onAdd={() => handleAddTanggalWhitelist()}
            rows={sortTanggalHariLibur}
            formatTanggal={(data) => data.tanggal}
            onDelete={handleDeleteTanggalWhitelist}
          />
        )}
      </div>
    </div>
  );
};
export default WhiteList;
